<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="110px" :rules="rules">
      <el-form-item label="参数ID" prop="parameter_id">
        <el-input v-model="ruleForm.parameter_id" disabled />
      </el-form-item>
      <el-form-item label="参数类型" prop="parameter_type_1">
        <el-cascader :options="parameterTypeTree" :props="{ value: 'type_id',label: 'type_desp', children: 'child'}" v-model="parameter_types" @change="handleChange" style="width: 100%;" />
      </el-form-item>
      <el-form-item label="参数名称" prop="parameter_name">
        <el-input v-model="ruleForm.parameter_name" maxlength="20" show-word-limit />
      </el-form-item>
      <el-form-item label="数值类型" prop="parameter_value_type">
        <el-select v-model="ruleForm.parameter_value_type" disabled>
          <el-option
            v-for="item in numericTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item ref="parameterUnit" v-if="ruleForm.parameter_value_type === 1" label="单位" prop="parameter_unit">
        <el-input v-model="ruleForm.parameter_unit" maxlength="16" show-word-limit />
      </el-form-item>
      <el-form-item ref="parameterInputRange" v-if="ruleForm.parameter_value_type === 2" label="列表范围" prop="parameter_input_range" :rules="{ required: true, message: '请输入列表范围', trigger: 'blur' }">
        <el-input v-model="ruleForm.parameter_input_range" />
      </el-form-item>
      <el-form-item label="参数说明" prop="parameter_desp">
        <el-input v-model="ruleForm.parameter_desp" maxlength="200" show-word-limit />
      </el-form-item>
      <el-form-item v-if="ruleForm.parameter_value_type === 1" label="建议输入范围" prop="parameter_input_range">
        <el-input v-model="ruleForm.parameter_input_range" maxlength="64" show-word-limit />
      </el-form-item>
      <el-form-item label="参数默认值" prop="parameter_default_value">
        <el-input v-model="ruleForm.parameter_default_value" maxlength="32" show-word-limit />
      </el-form-item>
      <el-form-item label="控制角色" prop="parameter_roles">
        <el-select v-model="ruleForm.parameter_roles" multiple>
          <el-option
            v-for="item in roleList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import BasicDataHelper from '@/api/basic_data_helper'
import Backend from '@/api/backend'

export default {
  name: '',
  data () {
    return {
      service: 'device_model_parameter',
      id_name: 'device_model_parameter_id',
      numericTypes: BasicDataHelper.numericTypes,
      ruleForm: {},
      rules: {
        parameter_id: [
          { required: true, message: '请输入参数ID', trigger: 'blur' }
        ],
        parameter_type_1: [
          { required: true, message: '请选择参数类型', trigger: 'change' }
        ],
        parameter_name: [
          { required: true, message: '请输入参数名称', trigger: 'blur' }
        ],
        parameter_value_type: [
          { required: true, message: '请选择数值类型', trigger: 'change' }
        ],
        parameter_unit: [
          { required: true, message: '请输入单位', trigger: 'blur' }
        ],
        parameter_default_value: [
          { required: true, message: '请输入参数默认值', trigger: 'blur' }
        ]
      },
      parameter_types: [],
      parameter_types_backup: []
    }
  },

  props: ['deviceModelId', 'parameterTypeTree', 'rowData', 'roleList'],

  created () {
    this.getRow(this.rowData)
  },

  methods: {
    getRow (data) {
      for (const k in data) {
        this.$set(this.ruleForm, k, data[k])
      }

      this.ruleForm.parameter_roles = this.ruleForm.parameter_roles.map(id => JSON.stringify(id))
      this.parameter_types = this.parameter_types_backup = this.getParameterTypes()
    },
    getParameterTypes () {
      const data = []
      for (let i = 1; i < 4; i++) {
        const val = this.ruleForm[`parameter_type_${i}`]
        if (val !== '-1') data.push(Number(val))
      }
      return data
    },
    handleChange (data) {
      this.setParameterTypeVal(data)
    },
    resetForm () {
      this.parameter_types = this.parameter_types_backup
      this.setParameterTypeVal(this.parameter_types_backup)
      this.$refs.ruleForm.resetFields()
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = { device_model_id: this.deviceModelId }
          for (const k in this.ruleForm) {
            params[k] = this.ruleForm[k]
          }
          params.parameter_roles = params.parameter_roles.join(',')
          Backend.editRow(this, params, undefined, '参数')
        }
      })
    },
    setParameterTypeVal (data) {
      this.ruleForm.parameter_type_1 = data[0]
      this.ruleForm.parameter_type_2 = data[1] !== undefined ? data[1] : -1
      this.ruleForm.parameter_type_3 = data[2] !== undefined ? data[2] : -1
    }
  }
}
</script>
